module.exports = [{
      plugin: require('/opt/build/repo/packages/site/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-66485739-18"},
    },{
      plugin: require('/opt/build/repo/packages/site/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
